import { License, ManagedAccount } from '@webdev/user-management';
import { map } from 'lodash-es';
import React, { ChangeEvent } from 'react';
import { CheckboxInput } from '../forms/CheckboxInput';
import { useGetAllManagedLicenses } from './useGetAllManagedLicenses';
import { useGetLicencesByUser } from './useGetLicencesByUser';
import { useSetManagedLicensesToUser } from './useSetManagedLicensesToUser';

interface UserDetailsProps {
  userId: ManagedAccount['id'];
}

const UserDetails: React.FC<UserDetailsProps> = ({ userId }) => {
  const { managedLicenses } = useGetAllManagedLicenses();
  const licenseIds = map(managedLicenses, 'id') as Array<License['id']>;
  const { allocatedLicenses } = useGetLicencesByUser(userId);
  const { setManagedLicenses, isUpdating } = useSetManagedLicensesToUser(userId);

  const toggleLicense = async (event: ChangeEvent<HTMLInputElement>, license: License['id']) => {
    const newAllocatedLicenses: Array<License['id']> = event.target.checked
      ? allocatedLicenses.concat([license])
      : allocatedLicenses.filter((l) => l === license);
    setManagedLicenses(newAllocatedLicenses);
  };

  const toggleAll = async (event: ChangeEvent<HTMLInputElement>) => {
    event.target.checked ? setManagedLicenses(licenseIds) : setManagedLicenses([]);
  };

  return (
    <tr>
      <td />
      <td colSpan={4} className='users__table-row-details f5'>
        <CheckboxInput
          label='All'
          disabled={isUpdating}
          onChange={toggleAll}
          checked={allocatedLicenses.length === licenseIds.length}
        />
        <hr />
        {managedLicenses.map(({ id, productName }) => {
          return (
            <CheckboxInput
              key={id}
              disabled={isUpdating}
              onChange={(event) => toggleLicense(event, id)}
              label={productName}
              checked={allocatedLicenses.includes(id)}
            />
          );
        })}
      </td>
    </tr>
  );
};

export default UserDetails;
